import * as _ from 'lodash';
import { createContext } from 'react';

import type { SetState } from '../../../../../types';
import type { DependencyInfoOption, ReportExclusionOptions } from '../../shared/types';
import type {
  DependencyMetadataFilterOption,
  FormatName,
  IncludeFilterOption,
  IncludeFixPlanFilterOption,
} from '../shared/types';

type Context = {
  dependencyInfoOptions: DependencyInfoOption[];
  setDependencyInfoOptions: SetState<DependencyInfoOption[]>;
  format: FormatName | null;
  setFormat: SetState<FormatName | null>;
  includeOptions: IncludeFilterOption[];
  setIncludeOptions: SetState<IncludeFilterOption[]>;
  dependencyMetadataOptions: DependencyMetadataFilterOption[];
  setDependencyMetadataOptions: SetState<DependencyMetadataFilterOption[]>;
  excludeOptions: ReportExclusionOptions;
  setExcludeOptions: SetState<ReportExclusionOptions>;
  fixPlanOptions: IncludeFixPlanFilterOption[];
  setFixPlanOptions: SetState<IncludeFixPlanFilterOption[]>;
  authorName: string;
  setAuthorName: SetState<string>;
  authorEmail: string;
  setAuthorEmail: SetState<string>;
  supplier: string;
  setSupplier: SetState<string>;
};

export const ReportContainerContext = createContext<Context>({
  dependencyInfoOptions: [],
  setDependencyInfoOptions: _.noop,
  format: null,
  setFormat: _.noop,
  includeOptions: [],
  setIncludeOptions: _.noop,
  dependencyMetadataOptions: [],
  setDependencyMetadataOptions: _.noop,
  excludeOptions: {},
  setExcludeOptions: _.noop,
  fixPlanOptions: [],
  setFixPlanOptions: _.noop,
  authorName: '',
  setAuthorName: _.noop,
  authorEmail: '',
  setAuthorEmail: _.noop,
  supplier: '',
  setSupplier: _.noop,
});

export const Provider = ReportContainerContext.Provider;
